module.exports = __webpack_public_path__ + "03fa45a471d1d7fff72a04687679fb90.MP3";